export const CATEGORY_MENU_TRIGGER_ID = 'category-drawer-trigger';
export const CATEGORY_MENU_HEADER_ID = 'category-drawer-header';
